import React, { Component } from 'react';
import FaPlusCircle from 'react-icons/lib/fa/plus-circle';
import FaMinusCircle from 'react-icons/lib/fa/minus-circle';
import { merge } from 'ramda';
import moment from 'moment';

import * as actionCreators from '../store/actions';
import { DatePicker } from './calendar.js';
import { connect } from 'react-redux';

class StatisticsRow extends Component {
  constructor() {
    super();
    this.increment = this.increment.bind(this);
    this.decrement = this.decrement.bind(this);
  }
  increment() {
    this.props.incrementEntry(this.props.day, this.props.entry[1]);
  }
  decrement() {
    this.props.decrementEntry(this.props.day, this.props.entry[1]);
  }
  render() {
    const count = this.props.fields[this.props.entry[1]] || 0;
    return (
      <li className="list-group-item d-flex flex-row">
        <div className="" style={{flexGrow: 1}}>{this.props.entry[0]}</div>
        <div className="" style={{margin: "0 0.5rem"}}><FaPlusCircle onClick={this.increment} /></div>
        <div className="" style={{margin: "0 0.5rem"}}>{count}</div>
        <div className="" style={{margin: "0 0.5rem"}}><FaMinusCircle onClick={this.decrement} /></div>
      </li>
    )
  }
}

const rowSelector = (state) => ({fields: state.visitorCounts.fields});
const StatisticsRowComponent = connect(rowSelector, actionCreators)(StatisticsRow);

class StatisticsBox extends Component {
  render() {
    return (
      <div className="col-sm">
        <div className="card" style={{marginBottom: "1rem"}}>
          <div className="card-header"><h2>{this.props.tab.name}</h2></div>
          <ul className="list-group list-group-flush">
            {this.props.tab.entries.map( (entry) =>
              <StatisticsRowComponent key={entry[1]} entry={entry} day={this.props.day} />)}
          </ul>
        </div>
      </div>
    );
  }
}

class StatisticsView extends Component {
  constructor() {
    super();
    this.dateChange = this.dateChange.bind(this);
    this.state = { day: moment().format('YYYY-MM-DD') };
  }
  componentWillMount() {
    this.props.fetchTabs();
    this.props.fetchCounts(this.state.day);
  }
  dateChange(newDate) {
    this.setState(merge(this.state, { day: newDate }));
    this.props.fetchCounts(newDate);
  }
  render() {
    const tabs = this.props.tabs || [];
    const day = this.state.day;
    return (
      <div>
        <DatePicker date={this.state.day} onChange={this.dateChange} displayFormat="ddd, MMM Do, YYYY" />
        <div className="row">
          {tabs.map( (tab) => <StatisticsBox key={tab.prefix} day={day} tab={tab}/> )}
        </div>
      </div>
    );
  }
}

const selector = (state) => ({tabs: state.tabs});
export const StatisticsComponent = connect(selector, actionCreators)(StatisticsView);



// WEBPACK FOOTER //
// ./src/components/stats.js